.delete-btn {
  margin: auto;
}

.delete-btn-icon {
  fill: var(--gray-818F9C);
  width: 14px;
}
